import { number, object } from 'yup';

export const scheme = object().shape({
  year: number().min(1800).max(new Date().getFullYear()).required(),
  revenue: number().min(0).nullable(),
  numEmployees: number().min(1).nullable(),
});
